import { render, staticRenderFns } from "./PurchasePaymentListView.vue?vue&type=template&id=c0ed895c"
import script from "./PurchasePaymentListView.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports